import React from "react";
import { useMediaQuery } from '@mui/material';
import Header from "../components/Header";
import MobileHeader from "../components/MobileHeader";
import PageHeader from "../components/About/PageHeader";
import OurPlans from "../components/CryptoSignal/OurPlans";
import Testimonial from "../components/Home/Testimonial";
import Footer from "../components/Footer";
import Subscribe from "../components/Home/Subscribe";
import Pricing from "../components/CryptoSignal/Pricing";
import ServiceInfo from "../components/CryptoSignal/ServiceInfo";
import BrokerSection from "../components/CryptoSignal/BrokerSection";
import ProfessionalTradersSection from "../components/CryptoSignal/ProfessionalTradersSection";
import AboutComponent from "../components/About/AboutComponent";
import AboutBanner from "../components/About/AboutBanner";
import Story from "../components/About/Story";
import Roadmap from "../components/About/Roadmap";

function About() {
  // Use useMediaQuery to detect if the screen size is mobile
  const isMobile = useMediaQuery('(max-width: 990px)');
  return (
    <div>
      {!isMobile && <Header />} {/* Render Header only on desktop view */}
      {isMobile && <MobileHeader />}{" "}
      {/* Render MobileHeader only on mobile view */}
      <AboutBanner />
      <Story />
      <AboutComponent />
      <Roadmap />
      {/* <Subscribe /> */}
      <Footer />
    </div>
  );
}

export default About;
